import { ButtonWithLoading } from "@dexteel/mesf-core";
import { Pause, PlayArrow } from "@mui/icons-material";
import { Button, ButtonGroup, Grid2 as Grid } from "@mui/material";
import { useEffect } from "react";
import { useDataEntryContext } from "../context/reducer.provider";
import { useTimerContext } from "../context/timer.provider";
import { useEAFDataEntryActions } from "../hooks/useEAFDataEntryActions";

export const RefreshButtons = () => {
	const {
		state: { isDataLoading, deProcess },
	} = useDataEntryContext();
	const { refreshData } = useEAFDataEntryActions();

	const { seconds, isRunning, pause, restart, resume } = useTimerContext();

	useEffect(() => {
		restart();
	}, [deProcess?.process?.ProcessId]);

	return (
		<Grid container direction={"column"} spacing={1} style={{ width: "100%" }}>
			<Grid style={{ width: "100%" }}>
				<ButtonGroup fullWidth>
					<ButtonWithLoading
						onClick={() => {
							pause();
							refreshData().then(() => {
								restart();
								resume();
							});
						}}
						fullWidth
						variant={"contained"}
						color={"primary"}
						isLoading={isDataLoading}
						size="large"
						style={{ fontSize: "0.9rem" }}
					>
						Refresh in {seconds}
					</ButtonWithLoading>
					<Button
						size="large"
						style={{
							maxWidth: "40px",
						}}
						onClick={() => {
							isRunning ? pause() : resume();
						}}
					>
						{isRunning ? <Pause /> : <PlayArrow />}
					</Button>
				</ButtonGroup>
			</Grid>
		</Grid>
	);
};
